import { getSelectedOrganizationId } from '../../selectors/organizations/organizations';
import { mediaAssetsService } from '../../transport/services';
import { errorLogger } from '../../utils/error-logger/error-logger';
import { isMetadataNotReady } from '../../utils/metadata/metadata';
import {
  callWithRetry,
  callWithRetryRejectedResponseMessage,
} from '../../utils/promise';
import { BI_ERRORS } from '../../utils/statistics/bi-error-logger/bi-errors';
import { getProjectByRoute } from '../projects/projects.selectors';
import { Dispatch, GetState } from '../redux.types';

import {
  getFileMetadataMap,
  getMetadataLoadingStateMap,
} from './metadata.selectors';

export const METADATA_ACTIONS = {
  METADATA_GET_START: 'METADATA_ACTIONS.METADATA_GET_START',
  METADATA_GET_SUCCESS: 'METADATA_ACTIONS.METADATA_GET_SUCCESS',
  METADATA_GET_ERROR: 'METADATA_ACTIONS.METADATA_GET_ERROR',
};

export const getFileMetadata =
  (fileId: string) =>
  (dispatch: Dispatch, getState: GetState): void => {
    const state = getState();
    const organizationId = getSelectedOrganizationId(state);
    const project = getProjectByRoute(state);
    const metadataStateMap = getMetadataLoadingStateMap(state);

    if (metadataStateMap[fileId]) {
      return;
    }

    dispatch({
      types: [
        METADATA_ACTIONS.METADATA_GET_START,
        METADATA_ACTIONS.METADATA_GET_SUCCESS,
        METADATA_ACTIONS.METADATA_GET_ERROR,
      ],
      additionalData: {
        fileId,
      },
      callApi: () =>
        callWithRetry(
          () =>
            mediaAssetsService.getFileMetadataById({
              id: fileId,
              project,
              organizationId,
            }),
          {
            retryInterval: 3000,
            maxTries: 3,
            isBadResultFn: isMetadataNotReady,
          },
        ),
    }).catch((reason) => {
      if (reason === callWithRetryRejectedResponseMessage) {
        errorLogger.logInfo({
          description: BI_ERRORS.fileManager.fileMetadata.name,
          otherParams: { reason, fileId },
        });

        return;
      }

      errorLogger.logError({
        biErrorDescription: BI_ERRORS.fileManager.fileMetadata,
        errorDescription: BI_ERRORS.fileManager.fileMetadata,
        otherParams: { reason, fileId },
      });
    });
  };

export const getFileMetadataCached =
  (fileId: string) =>
  (dispatch: Dispatch, getState: GetState): void => {
    const metadataMap = getFileMetadataMap(getState());

    if (metadataMap[fileId]) {
      return;
    }

    getFileMetadata(fileId)(dispatch, getState);
  };
